<template>
  <DialogTemplate>
    <div class="py-2 px-2 f-column tournament-phases mh-0">
      <div class="text-large weight_700 clr-primary">
        {{ $t('gameformat.tournament_phase') }}
      </div>
      <div class="weight_500 mb-4 clr-grey">
        {{ $t('tournament_phase_dialog.title_sub') }}
      </div>
      <TabBox
        style="
          flex: 1;
          --tbbox-content-clr-back: var(--clr-black-1-1);
          --tbbox-content-inner-padding: 1rem 1.5rem;
          --tbbox-content-padding: 0;
          --tbbox-tab-width: auto;
        "
        tabsStyle="
        --scrlr-z-index: 1;
        --clr-scrl-back: var(--clr-tbbox-tab-back);
        --clr-tab-hover-back: var(--clr-tbbox-tab-hover-back);
        --clr-tab-active-back: var(--clr-tbbox-tab-active-back);
        --height: 2.75rem;
        --height-inner: 3rem;
        --tab-fnt-size: 1rem;
        --tab-radius: 8px;
        --inner-flex: 1;
        --tab-flex: 1;
        --padding-inner: 0;
        --padding-tab: 0 1.5rem;
        --clr-tbbox-tab-back: transparent;
        --inner-flex: unset;
        "
        :options="[200, 1000]"
        @click="item => (playersNum = item)"
      >
        <template #tab="{ item }">
          {{ $t('common.num_players', { num: item }) }}
        </template>
        <div class="f-column mh-0">
          <div
            v-for="(item, index) in texts[`players_${playersNum}`]"
            :key="index"
            style="padding-bottom: 1.25rem"
          >
            <div class="weight_600">{{ item.title }}</div>
            <div class="weight_400 text-medium clr-grey mt-1">{{ item.sub }}</div>
          </div>
        </div>
      </TabBox>
    </div>
    <template #dialog_actions>
      <div class="w-100 f-row justify-space-between">
        <div
          class="gw_btn-v1 gw_btn_outline gw_btn_text clr-grey mr-auto my-auto"
          @click="$store.dispatch('router_set_dialogs', 'payouts-dialog')"
        >
          <i class="mdi mdi-currency-usd text-semi-large mr-1"></i>
          {{ $t('common.payouts') }}
        </div>
        <v-btn
          class="ml-auto"
          @click="close"
        >
          {{ $t('btn.close') }}
        </v-btn>
      </div>
    </template>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import TabBox from '@/components/lib/TabBox'

export default {
  name: 'TournamentPhaseDialog',
  components: {
    DialogTemplate,
    TabBox,
  },
  data() {
    return {
      playersNum: 200,
    }
  },
  methods: {
    close() {
      this.$store.dispatch('router_rm_dialog', 'tournament-phase-dialog')
    },
  },
  computed: {
    texts() {
      return {
        players_200: [
          {
            title: this.$t('tournament_phase_dialog.finale_table_title'),
            sub: this.$t('tournament_phase_dialog.finale_table_sub'),
          },
          {
            title: this.$t('tournament_phase_dialog.tables_2_title'),
            sub: this.$t('tournament_phase_dialog.tables_2_sub'),
          },
          {
            title: this.$t('tournament_phase_dialog.tables_3_title'),
            sub: this.$t('tournament_phase_dialog.tables_3_sub'),
          },
          {
            title: this.$t('tournament_phase_dialog.near_bubble_title'),
            sub: this.$t('tournament_phase_dialog.near_bubble_sub'),
          },
          {
            title: this.$t('tournament_phase_dialog.last25_title'),
            sub: this.$t('tournament_phase_dialog.last25_sub'),
          },
          {
            title: this.$t('tournament_phase_dialog.last37_title'),
            sub: this.$t('tournament_phase_dialog.last37_sub'),
          },
          {
            title: this.$t('tournament_phase_dialog.last50_title'),
            sub: this.$t('tournament_phase_dialog.last50_sub'),
          },
          {
            title: this.$t('tournament_phase_dialog.last70_title'),
            sub: this.$t('tournament_phase_dialog.last90_sub'),
          },
          {
            title: this.$t('tournament_phase_dialog.last90_title'),
            sub: this.$t('tournament_phase_dialog.last90_sub'),
          },
          {
            title: this.$t('tournament_phase_dialog.start_title'),
            sub: this.$t('tournament_phase_dialog.start_sub'),
          },
        ],
        players_1000: [
          {
            title: this.$t('tournament_phase_dialog.finale_table_title'),
            sub: this.$t('tournament_phase_dialog.finale_table_sub'),
          },
          {
            title: this.$t('tournament_phase_dialog.tables_2_title'),
            sub: this.$t('tournament_phase_dialog.tables_2_sub'),
          },
          {
            title: this.$t('tournament_phase_dialog.tables_3_title'),
            sub: this.$t('tournament_phase_dialog.tables_3_sub'),
          },
          {
            title: this.$t('tournament_phase_dialog.players_1000.last5_title'),
            sub: this.$t('tournament_phase_dialog.players_1000.last5_sub'),
          },
          {
            title: this.$t('tournament_phase_dialog.players_1000.last10_title'),
            sub: this.$t('tournament_phase_dialog.players_1000.last10_sub'),
          },
          {
            title: this.$t('tournament_phase_dialog.near_bubble_title'),
            sub: this.$t('tournament_phase_dialog.players_1000.near_bubble_sub'),
          },
          {
            title: this.$t('tournament_phase_dialog.players_1000.middle_bubble_title'),
            sub: this.$t('tournament_phase_dialog.players_1000.middle_bubble_sub'),
          },
          {
            title: this.$t('tournament_phase_dialog.players_1000.early_bubble_title'),
            sub: this.$t('tournament_phase_dialog.players_1000.early_bubble_sub'),
          },
          {
            title: this.$t('tournament_phase_dialog.last25_title'),
            sub: this.$t('tournament_phase_dialog.players_1000.last25_sub'),
          },
          {
            title: this.$t('tournament_phase_dialog.last37_title'),
            sub: this.$t('tournament_phase_dialog.players_1000.last37_sub'),
          },
          {
            title: this.$t('tournament_phase_dialog.last50_title'),
            sub: this.$t('tournament_phase_dialog.players_1000.last50_sub'),
          },
          {
            title: this.$t('tournament_phase_dialog.players_1000.last75_title'),
            sub: this.$t('tournament_phase_dialog.players_1000.last75_sub'),
          },
        ],
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.tournament-phases {
  max-width: 520px;
}
@media (max-width: 1023px) {
  .tournament-phases {
    max-width: 100%;
  }
}
</style>
